module.exports = __webpack_public_path__ + "static/aboutme_3-32365f778588651e5db8ef1ef0878b86.jpg";